import InfoOutlined from "@mui/icons-material/InfoOutlined";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import MUITooltip from "@mui/material/Tooltip";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { TinyTextLighter as DefaultTinyTextLighter } from "./HXMobilePage.styles";
const radioIconSize = 42;
export const ProfilePopoverHeaderContainer = styled(FlexRowDiv) `
    display: flex;
    align-self: stretch;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    padding: 24px 16px 12px 16px;
    box-sizing: border-box;
    border-bottom: 1px solid ${colors.black_12};
`;
export const ProfileHeroAvatarNameRow = styled(FlexRowDiv) `
    flex: 1;
    min-width: 0;
    align-items: center;
    gap: 16px;
`;
export const ProfileHeroNameBlock = styled(FlexColumnDiv) `
    flex: 1;
    min-width: 0;
    gap: 0px;
`;
export const ProfileHeroFirstNameRow = styled(FlexRowDiv) `
    align-items: center;
    width: 100%;

    & > :first-child {
        flex: 1;
        min-width: 0;
    }
`;
export const ProfileAvatarWrapper = styled.div `
    position: relative;
    flex-shrink: 0;
`;
export const ProfileAvatarUploadOverlay = styled.div `
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 12px;
`;
export const Parent = styled(FlexColumnDiv) `
    gap: 0;
    position: relative;
    padding-bottom: 40px;
`;
export const ProfilePopoverContent = styled(FlexColumnDiv) `
    gap: 24px;
    padding: 24px;
    box-sizing: border-box;
    align-self: stretch;
`;
export const RadioIcon = styled(Radio) `
    width: ${radioIconSize}px;
    height: ${radioIconSize}px;
`;
export const InfoOutlinedIcon = styled(InfoOutlined) `
    width: 24px;
    height: 24px;
    color: ${colors.black_lighter};
    display: block;
`;
export const Tooltip = styled(MUITooltip) ``;
export const TooltipContent = styled(FlexColumnDiv) `
    width: 200px;
`;
export const FormControlLabel = styled(MUIFormControlLabel) `
    align-self: stretch;
    .MuiSvgIcon-root {
        width: 24px;
        height: 24px;
    }

    &.MuiFormControlLabel-labelPlacementEnd {
        margin-left: 0; // There's a default -11 left-margin
    }
`;
export const TinyTextLighter = styled(DefaultTinyTextLighter) `
    margin-left: ${radioIconSize}px;
`;
export const TwilioFromPhoneNumber = styled.span `
    text-decoration-line: underline;
`;
const DialogText = styled.div `
    font-size: ${fontSizes.TINY};
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.4px;
`;
export const SpinnerText = styled(DialogText) `
    color: ${colors.black_lighter};
`;
export const DialogFooter = styled(DialogText) `
    color: ${colors.black_main};
`;
export const ConfirmDialogLink = styled.span `
    text-decoration-line: underline;
    cursor: pointer;
`;
